import type { SubsSection, SubRowVariant } from '@/msgdeskRuntime/state'

type MenuMode = 'drafts' | 'trash' | 'favs'

export const subTemplateConfig = {
  main: {
    answers: 'auto',
    submsges: 'auto',
  },
  // Folder pages share the neutral 'folder' row (deskUi/rowTemplates/FolderRow)
  // instead of the per-row legacy 'auto' resolution.
  menu: {
    drafts: {
      answers: 'folder',
      submsges: 'folder',
    },
    trash: {
      answers: 'folder',
      submsges: 'folder',
    },
    favs: {
      answers: 'folder',
      submsges: 'folder',
    },
  },
  nested: 'auto',
} satisfies {
  main: Record<SubsSection, SubRowVariant>
  menu: Record<MenuMode, Record<SubsSection, SubRowVariant>>
  nested: SubRowVariant
}

export function mainTemplateVariant(section: SubsSection): SubRowVariant {
  return subTemplateConfig.main[section]
}

export function menuTemplateVariant(mode: MenuMode, section: SubsSection): SubRowVariant {
  return subTemplateConfig.menu[mode][section]
}

export function nestedTemplateVariant(): SubRowVariant {
  return subTemplateConfig.nested
}
